@if(loading()) {
<p-dialog [modal]="true" [closable]="false" [visible]="true" showHeader="false"
    [style]="{ width: '19rem', minWidth: '19rem'}">
    <div class="spinner-container">
        <p-progressSpinner strokeWidth="6" animationDuration="1.5s"
            [style]="{ width: '2rem', height: '2rem', margin: '0' }"></p-progressSpinner>
        {{ 'VoiceLoad' | translate }}
    </div>
</p-dialog>
}